<template>
    <div class="pl-lg-4">
        <div class="row">
            <div class="col-lg-2">
                <base-input alternative="">
                    <select
                        class="form-control form-control-alternative"
                        v-model="page"
                        @change="getPageItems()"
                        :disabled="isLoadingBlade"
                    >
                        <option
                            v-for="(number, index) in visiblePages"
                            :key="index"
                            :value="number"
                        >
                            {{ number }}
                        </option>
                    </select>
                </base-input>
            </div>
            <div class="col-lg-8"></div>
            <div class="col-lg-2">
                <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fas fa-filter"></i> </span>
                    </div>
                    <select
                        class="form-control"
                        v-model="year"
                        @change="loadCertificates()"
                        :disabled="isLoadingBlade"
                    >
                        <option v-for="(year, index) in years" :key="index" :value="year">
                            {{ year }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-lg-12" v-if="isLoadingBlade">
                <div class="d-flex justify-content-center">
                    <img :src="loadingBladeUrl" />
                </div>
            </div> 

            <div class="col-lg-12" v-if="! isLoadingBlade">
                <h4 class="text-uppercase text-center">
                    License Year  
                    <strong class="text-danger">
                        {{ this.year }}
                    </strong>
                     – CPD Points Accumulated from WCEA Platform
                </h4>
                <hr>
            </div>
        </div>

            <!-- import Cpd records template here -->
            <CpdPointsData 
                v-bind:cpdRecords="cpdRecords"
                v-bind:pagination="pagination"
                v-bind:hasPagination="hasPagination"
                v-bind:paginate="paginate"
                :year="year"
                :total="total"
                v-if="! isLoadingBlade && cpdRecords && cpdRecords.length > 0"
            /> 
        <div class="row">
            <div class="col-sm-12 text-center" v-if="! isLoadingBlade && showErrorStatus">
                <base-alert :type="errorType">
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                </base-alert>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import flatPicker from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import CpdPointsData from './CpdPointsData.vue';
    import swal from 'sweetalert';// import sweet alert

    export default {
        components: {
            flatPicker,
            CpdPointsData
        },
        name: 'CpdPoints',
        data() {
            return {
                cpdRecords: [],
                paginatedItems: [],
                pagination: {
                    total: null,
                    prev_page_url: null,
                    next_page_url: null,
                    current_page: null,
                    last_page: null,
                    number: 1,
                    from: 0,
                    to: null,
                    perPage: this.$store.state.user.perPage // get per page count
                },
                total: 0,
                page: 1,
                year: new Date().getFullYear()+1,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false,
                isLoadingBlade: true
            };
        },
        computed: {
            ...mapGetters(['loadingBladeUrl', 'visiblePages']),
            hasPagination() {
                return this.paginatedItems && (this.paginatedItems.length > this.pagination.perPage)
                    ? true : false;
            },
            years() {
                let startYear = parseInt(this.$store.state.user.wceaStartYear) + 1;
                let endYear = new Date().getFullYear() + 1; 
                let years = [];
                for (let i = startYear; i <= endYear; i++) {
                    years.push(i);
                }
                return years;
            }
        },
        methods: {
            ...mapActions(['getUserCpdPoints', 'getPaginatedApplicationItems', 'fetchNewPageData']),
            loadCpdPoints() {
                let data = {
                    year : this.year,
                    limit : this.pagination.perPage 
                };
                this.getUserCpdPoints(data).then((res) => {// get edu records
                    this.setPages(res);
                    this.isLoadingBlade = false;
                }).
                catch(() => {
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!", "Kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            setPages(response) {// set paginated function
                let res = response.records;
                this.total = 0;
                this.cpdRecords = [];
                this.paginatedItems = res.data;
                this.cpdRecords = this.paginatedItems;
                this.pagination.from = res.from;
                this.pagination.to = res.to;
                this.pagination.total = res.total;
                this.pagination.current_page = res.current_page;
                this.pagination.last_page = res.last_page;
                this.pagination.prev_page_url = res.prev_page_url;
                this.pagination.next_page_url = res.next_page_url;
                this.fetchNewPageData({// handle pagination numbers
                    current_page : res.current_page,
                    last_page : res.last_page
                });
                this.total = response.total;// total CPD points accumulated for the specific year
                this.isLoadingBlade = false;
                this.emptyCpdRecordsMsg();//show empty msg
            },
            getPageItems() {
                let newUrl = '';
                let url = this.pagination.next_page_url ?
                            this.pagination.next_page_url : this.pagination.prev_page_url;
                let exploded = url.split('&');
                exploded.pop();// remove the page item
                for(let item of exploded) { newUrl += item +'&'; }// create url from exploded url
                newUrl += 'page='+this.page;// add new page item
                this.isLoadingBlade = true
                this.getPaginatedApplicationItems(newUrl).then((res) => {// get records
                    this.pagination.number = res.current_page;
                    this.setPages(res);
                }).
                catch(() => {
                    this.cpdRecords = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            paginate() {// paginate function
                this.showErrorStatus = false;
                let url = (this.pagination.number > this.pagination.current_page) ?
                    this.pagination.next_page_url : this.pagination.prev_page_url;
                if(url) {// make api call
                    this.isLoadingBlade = true
                    this.getPaginatedApplicationItems(url).then((res) => {// get users
                        this.pagination.number = res.current_page;
                        this.setPages(res);
                    }).
                    catch(() => {
                        this.cpdRecords = [];
                        this.showErrorStatus = true;
                        this.isLoadingBlade = false;
                        this.errorMsg = "Network Failure!, Kindly reload the page...";
                        this.errorType = 'danger';
                    });
                } else {
                    this.cpdRecords = this.paginatedItems;
                }
            },
            emptyCpdRecordsMsg() {
                return this.cpdRecords && this.cpdRecords.length == 0 ? this.showEmptyMsg() : false;
            },
            showEmptyMsg() {// show empty msg
                this.showErrorStatus = true; 
                this.errorType = 'warning';
                this.errorMsg = 'No CPD Points for the ' + this.year + '!, kindly take a course or update points from WCEA Certificates Menu';
            }
        }
    }
</script>

<style>
    .form-control-label {
        width: 100%;
    }
</style>